import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { bindActionCreators, compose } from 'redux'
import { connect } from 'react-redux'
import { adminNewGroupOptions, groupTableOptions, partnerNewGroupOptions } from '../constants/tableConfigs'
import { fetchClientList } from '../modules/client'
import { fetchGroupProfile } from '../modules/group'
import FormDialog from '../components/formDialog'
import { fetchGroups, patchGroupUsers, postGroup, putGroup, removeGroup } from '../modules/group'
import { fetchPartner } from '../modules/user'
import Messages from '../constants/messages'
import { nordAdmins } from '../constants/memberships'
import { paginationChangePage,
  paginationChangeRowsPerPage,
  searchOnChange } from '../modules/table'
import { push } from 'react-router-redux'
import { required, requiredMultiSelect } from '../utils/validationRules'
import { setFormValues, showDialog, resetForm, resetFormValue, resetLookUpValue, setConfirmationItem } from '../modules/formDialog'
import TableDisplay from '../components/tableDisplay'
import withStyles from 'material-ui/styles/withStyles'
import { getAdminTypeString, hasMembership } from '../utils/helpers'
import { unflagDataRefresh } from '../modules/refresh'

const PROP_TYPES = {
  classes: PropTypes.object.isRequired,
  groups: PropTypes.array.isRequired,
  partners: PropTypes.array,
  roles: PropTypes.array,
  totalCount: PropTypes.number.isRequired
}

const styles = theme => ({
  root: {
    maxWidth: '100%',
    margin: 'auto'
  },
  pageMessage: theme.pageMessage,
  title: theme.title
})

export class Groups extends Component {

  tableOptions = groupTableOptions.map((tableOption) => {
    if (tableOption.displayType === 'link') {
      return Object.assign(tableOption, {
        callback: (group) => {
          if (!this.props.groupProfile.group || this.props.groupProfile.group.id !== group.id){
            this.props.fetchGroupProfile(group.id)
          }
          this.props.changePage(group)
        }
      })
    } else {
      return {...tableOption}
    }
  })

  groupTableButtons = {
    systemAdmin: [
      {
        buttonName: 'PersonAdd',
        callback: (group) => {
          this.props.setFormValues(group)
          this.props.showDialog(true, 'add')
        },
        tooltip: Messages['tooltips']['PERSON_ADD']
      },
      {
        buttonName: 'ModeEdit',
        callback: (group) => {
          this.props.setFormValues({...group, roleIds: group.roles})
          this.props.showDialog(true, 'edit')
        },
        tooltip: Messages['tooltips']['EDIT']
      },
      {
        buttonName: 'Clear',
        callback: (group) => {
          this.props.showDialog(true, 'clear')
          this.props.setConfirmationItem(group)
        },
        tooltip: Messages['tooltips']['DELETE']
      }
   ],
   default: [
    {
      buttonName: 'PersonAdd',
      callback: (group) => {
        this.props.setFormValues(group)
        this.props.showDialog(true, 'add')
      },
      tooltip: Messages['tooltips']['PERSON_ADD']
    }
   ]
  }


  dialogOptions = {
    'System-Admin': adminNewGroupOptions,
    'Application-Admin': partnerNewGroupOptions,
    'PartnerAccessAdmin': partnerNewGroupOptions,
    add: [
      {
        type: 'userSelectField',
        name:'newUsers',
        friendlyName: Messages['uiComponents']['ADD_USER_TO_GROUP_SELECT_FIELD'],
        validationRules: [required]
      }
    ],
    edit: [
      {
        type: 'roleDropdown',
        name: 'roleIds',
        friendlyName: Messages['uiComponents']['ROLES_DROPDOWN_FIELD'],
        validationRules: [required, requiredMultiSelect]
      },
      {
        type: 'textField',
        name:'name',
        friendlyName: Messages['uiComponents']['GROUP_NAME_INPUT_FIELD'],
        validationRules: [required]
      },
      {
        type: 'textField',
        name:'description',
        friendlyName: Messages['uiComponents']['GROUP_DESCRIPTION_INPUT_FIELD'],
        validationRules: [required]
      }
    ],
    clear: [
      {
        type: 'confirmation',
        name:'name',
        confirmationType: 'delete'
      }
    ]
  }

  getProgressIndicatorText(formType) {
    switch(formType) {
      case 'new':
        return Messages['uiComponents']['CREATING_MSG']
      case 'add':
        return Messages['uiComponents']['ADDING_USER_MSG']
      case 'edit':
        return Messages['uiComponents']['UPDATING_MSG']
      case 'clear':
        return Messages['uiComponents']['DELETING_GROUP_MSG']
      default:
        return Messages['uiComponents']['LOADING_MSG']
    }
  }

  setTitle(formType) {
    switch(formType) {
      case 'new':
        return Messages['uiComponents']['CREATE_GROUP_TITLE']
      case 'add':
        return Messages['uiComponents']['ADD_USER_TO_GROUP_TITLE']
      case 'edit':
        return Messages['uiComponents']['EDIT_GROUP_TITLE']
      case 'clear':
        return Messages['uiComponents']['DELETE_GROUP_TITLE']
      default:
        return ''
    }
  }

  handleSubmit(formValues) {
    const {
      applicationId,
      confirmationItem,
      formType,
      lookUpValue,
      patchGroupUsers,
      postGroup,
      putGroup,
      resetForm,
      removeGroup,
      userMemberships,
      userList } = this.props
    switch(formType) {
      case 'new':
        if (hasMembership(userMemberships, nordAdmins)) {
          postGroup({...formValues, applicationId}, lookUpValue)
        } else {
          let partner = JSON.parse(formValues.partner)
          formValues.partnerId = partner.id
          postGroup({...formValues, applicationId}, partner.name)
        }
        resetForm()
        break
      case 'edit':
        putGroup({...formValues, applicationId})
        resetForm()
        break
      case 'add':
        const user = userList.filter(user => {
          return user.id === formValues.newUsers
        })
        patchGroupUsers({...formValues, applicationId}, user)
        resetForm()
        break
      case 'clear':
        removeGroup(confirmationItem)
        resetForm()
        break
      default:
        break
    }
  }

  componentDidMount() {
    const { clientList, dataRefreshRequired, fetchClientList, fetchGroups, unflagDataRefresh } = this.props
    if (clientList.length === 0) {
      fetchClientList()
    }
    if (dataRefreshRequired) {
      unflagDataRefresh('groups')
      fetchGroups(true)
    }
  }

  render() {
    const {
      classes,
      clientList,
      fetchPartner,
      lookUpValue,
      confirmationItem,
      fetchGroups,
      formValues,
      formType,
      groups,
      isLoadingDialog,
      open,
      paginationChangePage,
      paginationChangeRowsPerPage,
      paginationPage,
      paginationRowsPerPage,
      partners,
      resetForm,
      resetFormValue,
      resetLookUpValue,
      roles,
      searchOnChange,
      searchValue,
      showDialog,
      totalCount,
      userMemberships,
      userRoles,
      userList } = this.props

    const adminType = getAdminTypeString(userMemberships, userRoles)

    return (
      <section className={classes.root}>
        <FormDialog
          buttonLabel={adminType === 'System-Admin' ? Messages['uiComponents']['CREATE_GROUP_BUTTON'] : null}
          dialogOptions={formType === 'new' ? this.dialogOptions[adminType] : this.dialogOptions[formType] }
          data={{userList, clientList, rolesList: roles, partnerList: partners}}
          handleFormSubmit={(values) => this.handleSubmit(values)}
          infoText={this.getProgressIndicatorText(formType)}
          isLoading={isLoadingDialog}
          initialValues={formValues}
          enableReinitialize={true}
          open={open}
          confirmationItem={confirmationItem}
          showDialog={showDialog}
          title={this.setTitle(formType)}
          resetFormValue={resetFormValue}
          resetFormValues={resetForm}
          resetLookUpValue={resetLookUpValue}
          lookUpValue={lookUpValue}
          lookUpFunc={fetchPartner} />
        <p className={classes.pageMessage}>{Messages['pageHeaders']['GROUPS_PAGE_MSG']}</p>
        <TableDisplay
          data={groups}
          fetchDataCallback={fetchGroups}
          page={paginationPage}
          paginationChangePage={paginationChangePage}
          paginationChangeRowsPerPage={paginationChangeRowsPerPage}
          rowsPerPage={paginationRowsPerPage}
          search={hasMembership(userMemberships, nordAdmins)}
          searchFieldLabel={Messages['uiComponents']['GROUP_SEARCH_LABEL']}
          searchOnChange={searchOnChange}
          searchValue={searchValue}
          serverSidePagination={true}
          tab="group"
          tableOptions={this.tableOptions}
          tableButtons={adminType === 'System-Admin' ? this.groupTableButtons.systemAdmin : this.groupTableButtons.default}
          totalCount={totalCount}
          type="group" />
      </section>
    )
  }
}
Groups.propTypes = PROP_TYPES

const mapStateToProps = state => ({
  applicationId: state.appContext.appInfo.id,
  clientList: state.client.clientList,
  confirmationItem: state.formDialog.confirmationItem,
  dataRefreshRequired: state.refresh.dataRefreshRequired.groups,
  formType: state.formDialog.formType,
  formValues: state.formDialog.formValues,
  groups: state.group.groups,
  groupProfile: state.group.groupProfile,
  isLoadingDialog: state.loading.isLoadingDialog,
  lookUpValue: state.formDialog.lookUpValue,
  open: state.formDialog.open,
  paginationPage: state.table.paginationPage.group,
  paginationRowsPerPage: state.table.paginationRowsPerPage.group,
  partners: state.authProfile.partners,
  roles: state.role.roles,
  searchValue: state.table.searchValues.group,
  totalCount: state.group.totalCount,
  userList: state.user.users,
  userMemberships: state.authProfile.userMemberships,
  userRoles: state.authProfile.userRoles,
})

const mapDispatchToProps = dispatch => bindActionCreators({
  changePage: (group) => push({pathname: `/groups/${group.id}`, state: group}),
  fetchClientList,
  fetchGroups,
  fetchGroupProfile,
  fetchPartner,
  showDialog,
  paginationChangePage,
  paginationChangeRowsPerPage,
  patchGroupUsers,
  postGroup,
  putGroup,
  setConfirmationItem,
  setFormValues,
  resetForm,
  resetFormValue,
  resetLookUpValue,
  removeGroup,
  searchOnChange,
  unflagDataRefresh
}, dispatch)

export default compose(
  withStyles(styles),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
)(Groups)
